import { CountryEnum } from '@/generated/graphql';

export const CountryFlag = (country: CountryEnum, index: number, totalCount: number) => (
  <span key={country}>
    <img alt={country} src={`https://flagcdn.com/16x12/${country.toLowerCase()}.png`} />
    {` ${country}`}
    {index === totalCount ? '' : ', '}
  </span>
);
